import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import {
  DyehouseDailyMetricDto,
  DyehouseDailyMetricImportCommand,
  DyehouseDailyMetricPreviewResultDto,
  DyehouseDailyMetricImportResultDto,
} from '../../models/production/dyehouse-daily-metric.model';

@Injectable({
  providedIn: 'root',
})
export class DyehouseDailyMetricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = `${environment.proxyUrls.productionApi}/api/v1/dyehouse-daily-metric`;

  getByPeriod(year: number, month: number): Observable<ApiResponse<DyehouseDailyMetricDto[]>> {
    const params = new HttpParams().set('year', String(year)).set('month', String(month).padStart(2, '0'));
    return this.httpClient.get<ApiResponse<DyehouseDailyMetricDto[]>>(`${this.apiUrl}/by-period`, {
      params,
      headers: { Accept: 'application/json' },
    });
  }

  import(
    command: DyehouseDailyMetricImportCommand,
  ): Observable<ApiResponse<DyehouseDailyMetricPreviewResultDto | DyehouseDailyMetricImportResultDto>> {
    const formData = new FormData();
    formData.append('file', command.file, command.file.name);

    const params = new HttpParams()
      .set('plantId', command.plantId)
      .set('preview', String(command.preview))
      .set('override', String(command.override));

    return this.httpClient.post<ApiResponse<DyehouseDailyMetricPreviewResultDto | DyehouseDailyMetricImportResultDto>>(
      `${this.apiUrl}/import-excel`,
      formData,
      { params, headers: { Accept: 'text/plain' } },
    );
  }
}
